import { render, staticRenderFns } from "./Riesgo.vue?vue&type=template&id=b5ca3b8c&scoped=true"
import script from "./Riesgo.vue?vue&type=script&setup=true&lang=js"
export * from "./Riesgo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Riesgo.vue?vue&type=style&index=0&id=b5ca3b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ca3b8c",
  null
  
)

export default component.exports